export * from './platform';
export * from './browser';


// WEBPACK FOOTER //
// ./~/@told/platform/src/index.ts